<template lang="pug">
.profile-page
  .container-fluid.profile-page-title
    .container
      p.title-path
        span {{ $t("profile.profile") }}
      p.title-user-name
        span {{ $t("profile.profile") }}
  .container-fluid.profile-details
    .container(v-if="!isEmpty(profile)")
      profile-details(:profile="profile")
      profile-links

</template>

<script>
  import {api} from '@/api'
  import { isEmpty } from 'lodash'
  import ProfileDetails from '@/pages/Profile/Page/profile-details'
  import ProfileLinks from '@/pages/Profile/Page/profile-links'

  export default {
    components: {
      ProfileDetails,
      ProfileLinks
    },
    
    data() {
      return {
        profile: {
          phones: []
        }
      }
    },
    
    computed: {
      profileUrl() {
        return `/profiles`
      }
    },

    created() {
      api.get(this.profileUrl).then(({ data: { success, data } }) => {
        if (success) {
          this.profile = data
        }
      })
    },

    methods: {
      isEmpty
    }
  }
</script>

<style lang="scss" scoped>
  .profile-page {
    padding-bottom: 100px;

    .profile-page-title {
      align-items: center;
      background: #fff;
      box-shadow: 0 2px 16px 0 rgba(176, 186, 197, 0.2);
      display: flex;
      font-weight: 700;
      height: 112px;
      margin-bottom: 10px;

      .title-path {
        a,
        span {
          color: #7c91a7;
          font-size: 11px;
          letter-spacing: 0;
        }

        a:hover {
          color: #7c91a7;
          text-decoration: none;
        }

        #arrow-delimiter {
          margin: 0 5px;
        }
      }

      .title-user-name {
        color: #3d4a57;
        font-size: 30px;
        letter-spacing: 0;
      }
    }

    .profile-details {
      background: #fcfdfe;
    }
  }
</style>
